import { createSlice } from '@reduxjs/toolkit';

const aiSetSlice = createSlice({
    name: 'aiSet',
    initialState: {
        seedTrack: null,           // { title, artist }
        setLength: 10,             // target number of tracks
        generatedTracks: [],       // array of track objects with metadata
        isGenerating: false,
        progress: 0,               // 0..setLength
        error: null,

        // Mix parameters
        transitionLength: 32,      // 8-64 beats
        trackPlay: 'long',         // 'short'|'medium'|'mediumPlus'|'long'

        // Mix rendering state
        isMixing: false,
        mixProgress: { step: '', percent: 0 },
        mixOutputPath: null,
        mixError: null,
    },
    reducers: {
        setSeedTrack: (state, action) => {
            state.seedTrack = action.payload;
        },
        setSetLength: (state, action) => {
            state.setLength = action.payload;
        },
        setTransitionLength: (state, action) => {
            state.transitionLength = action.payload;
        },
        setTrackPlay: (state, action) => {
            state.trackPlay = action.payload;
        },
        startGeneration: (state) => {
            state.isGenerating = true;
            state.generatedTracks = [];
            state.progress = 0;
            state.error = null;
        },
        addGeneratedTrack: (state, action) => {
            state.generatedTracks.push(action.payload);
            state.progress = state.generatedTracks.length;
        },
        setGenerationError: (state, action) => {
            state.error = action.payload;
            state.isGenerating = false;
        },
        finishGeneration: (state) => {
            state.isGenerating = false;
        },
        resetSet: (state) => {
            state.seedTrack = null;
            state.generatedTracks = [];
            state.progress = 0;
            state.error = null;
            state.isGenerating = false;
            state.isMixing = false;
            state.mixProgress = { step: '', percent: 0 };
            state.mixOutputPath = null;
            state.mixError = null;
        },
        removeTrack: (state, action) => {
            state.generatedTracks = state.generatedTracks.filter((_, i) => i !== action.payload);
        },
        reorderTracks: (state, action) => {
            state.generatedTracks = action.payload;
        },
        startMixing: (state) => {
            state.isMixing = true;
            state.mixProgress = { step: 'Starting...', percent: 0 };
            state.mixOutputPath = null;
            state.mixError = null;
        },
        setMixProgress: (state, action) => {
            state.mixProgress = action.payload;
        },
        finishMixing: (state, action) => {
            state.isMixing = false;
            state.mixOutputPath = action.payload;
        },
        setMixError: (state, action) => {
            state.isMixing = false;
            state.mixError = action.payload;
        },
    },
});

export const {
    setSeedTrack,
    setSetLength,
    setTransitionLength,
    setTrackPlay,
    startGeneration,
    addGeneratedTrack,
    setGenerationError,
    finishGeneration,
    resetSet,
    removeTrack,
    reorderTracks,
    startMixing,
    setMixProgress,
    finishMixing,
    setMixError,
} = aiSetSlice.actions;

export default aiSetSlice.reducer;
